<template>
	<div class="tooltip" ref="tooltip"></div>
</template>

<script>
	export default {
		methods: {
			show: function(){
				Object.assign(this.tooltip.style, {
					display: "block"
				});
			},
			hide: function(){
				Object.assign(this.tooltip.style, {
					display: "none"
				});
			},
			updatePosition: function(e){
				Object.assign(this.tooltip.style, {
					left: (e.pixel[0] + 20) + "px",
					top: e.pixel[1] + "px",
					display: "block"
				});
			},
			setMessage: function(message){
				this.tooltip.innerHTML = message;
			}
		},
		mounted: function(){
			this.tooltip = this.$refs.tooltip;
		}
	}
</script>

<style scoped>
	.tooltip {
		position: absolute;
		z-index: 1;
		background-color: white;
		font-size: 0.8rem;
		pointer-events: none;
		display: none;
		border: 1px solid #cccccc;
		padding: 2px;
	}
</style>